import React, { Component } from 'react';
import classNames from 'classnames';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import ReactDOM from 'react-dom';
import { Toolbar, Data, Editors, Formatters } from 'react-data-grid-addons';
import _ from 'lodash';
import { browserHistory, Link } from 'react-router';
import { Translate, Localize } from 'react-redux-i18n';
import { Field, FieldArray, reset } from 'redux-form';
import {
  Grid, Row, Col, Panel, Button, DropdownButton, ButtonToolbar, MenuItem,
  FieldGroup, Input, Breadcrumb,
} from 'react-bootstrap';
import { SkyLightStateless } from 'react-skylight';
import moment from 'moment';

import { UI_HEIGHT } from '../Common/constants';
import CashFormatter from '../Common/cashFormatter';
import Spinner from '../../components/Widgets/spinner';
import { Selection } from '../Common/selection';
import { InputField, DisabledInputField, ControlledInputField } from '../Common/inputField';
import { DatePicker, DisabledDatePicker, StartOfThisMonthDatePicker } from '../Common/datePicker';
import SalesInventoryInfo from '../../containers/Sales/salesInventoryInfo';
import ReturnModal from '../../containers/Returns/returnModal';
import {
  ROOT_URL, ROOT_API_URL, isESC, isHMM, isOLG, isGGI, isSUN, isCPG, isEKC, isVIP, isCCW,
  isLMH, isSDR, isCRW, isSV, isVAK,
} from '../../actions/root_url';
import SerialNumModal from '../../components/Dispatch/serialNumModal';

var DropDownEditor = Editors.DropDownEditor;

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

class CustomerReturnForm extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

        invoice: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        totalPrice: 0,
        showInventoryOpen: false,
        currentCustomer_id: null,
        selectedInventoryRow: {},
        curRow: '',
        curTotal: 0,
        curCRV: 0,
        curTax: 0,
        curRestock: 0,
        curRestockP: 0,
        curOverwrite: null,
        curNotation: '',
        curFinal: 0,
        ReturnFormatter: false,
        IsWeight: false,
        rowChosen: null,
        currentWeights: null,
        backLogWeights: [],
        serialNumOpen: false,
        totalLoaded: 0,
        currentRowIdx: null,
        currentSerialNo: '',
        serialArrData: [],
        checkNum: 0
      };

      this.handleResize = this.handleResize.bind(this);
    }

    componentWillMount() {
      if (!this.props.params.id) {
        if (!this.props.currentCustomer) {
          const query = this.props.location.query || {};
          if ((isESC || isEKC || isLMH || isSDR || isCRW) && query.fromInvoice) {
            this.props.selectSalesInvoice({SalesInvoice_id: query.fromInvoice});
          } else {
            this.context.router.push('/customerReturn/');
          }
        } else {
          this.setState({ currentCustomer_id: this.props.currentCustomer.id });
        }
      } else {
        this.props.fetchSalesReturnDetail(this.props.params.id);
      }
    }

    componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      const { currentSalesInvoice } = this.props;

      if (!currentSalesInvoice && this.props.currentCustomer) {
        if (this.props.currentCustomer.value) {
          this.props.fetchCustomerItem(this.props.currentCustomer.value);
        }
      } else if (typeof currentSalesInvoice === 'object' && currentSalesInvoice && currentSalesInvoice.SalesReturn_id != null) {
        this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
      } else if (typeof currentSalesInvoice === 'object' && currentSalesInvoice) { this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoice_id); } else if (currentSalesInvoice) { this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, 'InvoiceNum'); }
      // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
      const currentLocation = browserHistory.getCurrentLocation();
      const removeListener = browserHistory.listen((location, action) => {
        if (location.pathname !== currentLocation.pathname) {
          this.props.resetCurrentSalesInvoice();
          window.removeEventListener('resize', this.handleResize);
          removeListener();
        }
      })
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.salesInvoiceDetail && !this.props.params.id && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
        let invoice = { ...this.state.invoice, rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines, TaxRate: nextProps.salesInvoiceDetail.TaxRate, Discount: nextProps.salesInvoiceDetail.Discount, Savings: nextProps.salesInvoiceDetail.Savings, TotalPrice: nextProps.salesInvoiceDetail.TotalPrice,  };

        if ((isLMH || isSDR || isCRW) && invoice.Discount) {
          nextProps.salesInvoiceDetail.Sales_Invoice_Lines.map((r,i)=>{
            invoice.rows[i].UnitPrice = parseFloat((r.UnitPrice*(1-(invoice.Discount/100))).toFixed(7));
            invoice.rows[i].TotalPrice = parseFloat((r.TotalPrice*(1-(invoice.Discount/100))).toFixed(7));
          });
        }
        //this.props.setValue('customerReturnForm', 'InvoiceNum', { value: nextProps.salesInvoiceDetail.InvoiceNum, label: nextProps.salesInvoiceDetail.InvoiceNum });
        this.props.fetchUnpaidInvoices(nextProps.salesInvoiceDetail.Deliver_Customer_id);
        this.setState({ invoice });
      }
      if (nextProps.salesReturnDetail && this.props.params.id && nextProps.salesReturnDetail != this.props.salesReturnDetail) {
        this.props.fetchUnpaidInvoices(nextProps.salesReturnDetail.Deliver_Customer_id);
        const selectedRows = [...nextProps.salesReturnDetail.Sales_Return_Line];
        for (let i = 0; i < selectedRows.length; i++) {
          selectedRows[i].isSelected = true;
          selectedRows[i].ReturnedQuantity = (selectedRows[i].ReturnedQuantity - selectedRows[i].ReturnQuantity);
        }

        const invoice = {
          ...this.state.invoice, rows: selectedRows, selectedRows, TaxRate: nextProps.salesReturnDetail.TaxRate, Discount: nextProps.salesReturnDetail.Discount, Savings: nextProps.salesReturnDetail.Savings, TotalPrice: nextProps.salesReturnDetail.OriginalTotalPrice,
        };
        //returnedSavings: nextProps.salesReturnDetail.ReturnedSavings,
        this.setState({ invoice, curOverwrite: nextProps.salesReturnDetail.OverwriteFee, curRestock: nextProps.salesReturnDetail.RestockingFee, curRestockP: nextProps.salesReturnDetail.RestockingFeePercentage, curNotation: nextProps.salesReturnDetail.Note, });
      }
    }

    handleResize(e) {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }


    formatDate(date) {
      let formattedDate = `${date.getFullYear()}-`;

      formattedDate += `${date.getMonth() + 1}-`;
      if (date.getDate() < 10) {
        formattedDate += `0${date.getDate()}`;
      } else {
        formattedDate += date.getDate();
      }
      return formattedDate;
    }

    // calculateFinalTotal never called
    calculateFinalTotal(nextProps) {
      let Tax = nextProps.Tax;
      let Promo = nextProps.Promo;
      let RestockingFee = nextProps.RestockingFee;

      if (isNumeric(Tax)) {
        Tax = parseFloat(Tax);
      } else {
        Tax = 0;
      }
      if (isNumeric(Promo)) {
        Promo = parseFloat(Promo);
      } else {
        Promo = 0;
      }
      if (isNumeric(RestockingFee)) {
        RestockingFee = parseFloat(RestockingFee);
      } else {
        RestockingFee = 0;
      }

      return Tax + Promo - RestockingFee;
    }

    closeReturnModal = () => { this.setState({ ReturnModalOpen: false, IsWeight: false }); }

    openWeightModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: true }); }
    openQuantityModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: false }); }

    // remove the set of values from arry1 with the values of arry2
    findIntersect = (arry1, arry2) => {
      const arry3 = [];
      if (arry1) arry1.sort();
      if (arry2) arry2.sort();
      let k = 0;
      for (let i = 0; i < arry1.length; i++) {
        if (k < arry2.length && arry1[i] === arry2[k]) { k++; } else { arry3.push(arry1[i]); }
      }
      return arry3;
    }

    setWeights = (currentRow, currentWeights, currentTotalWeight) => {
      // let backLogWeights = [...this.state.backLogWeights];
      // let newEntry = { currentRow, currentWeights };
      // backLogWeights.push(newEntry);
      // this.setState({backLogWeights});
      const invoice = { ...this.state.invoice };
      const ReturnWeightsList = [];
      const selectedIndexes = [];
      for (let k = 0; k < currentWeights.length; k++) {
        if (currentWeights[k].isSelected) {
          ReturnWeightsList.push(parseFloat(roundTo(parseFloat(currentWeights[k].Weight), 2).toFixed(2)));
        }
      }
      for (let i = 0; i < this.state.invoice.rows.length; i++) {
        if ((currentRow === this.state.invoice.rows[i].SalesOrderLine_id) || (currentRow === this.state.invoice.rows[i].SalesInvoiceLine_id)) {
          if(isGGI) {
            invoice.rows[i].ReturnTotalPrice = parseFloat(roundTo(parseFloat(currentTotalWeight) * invoice.rows[i].SmallUnitPrice, 2)).toFixed(2);
            invoice.rows[i].UnitPrice = parseFloat(roundTo(parseFloat(currentTotalWeight) * invoice.rows[i].SmallUnitPrice / ReturnWeightsList.length, 2)).toFixed(2);
          } else {
            invoice.rows[i].ReturnTotalPrice = parseFloat(roundTo(parseFloat(currentTotalWeight) * invoice.rows[i].UnitPrice, 2)).toFixed(2);
          }
          invoice.rows[i].ReturnWeight = parseFloat(currentTotalWeight);
          invoice.rows[i].ReturnWeightsList = [...ReturnWeightsList];
          invoice.rows[i].ReturnQuantity = ReturnWeightsList.length;
          if (this.props.params.id) {
            invoice.rows[i].ReturnCRV = parseFloat(roundTo((invoice.rows[i].CRV) * ReturnWeightsList.length), 2).toFixed(2) || invoice.rows[i].ReturnCRV || 0;
          } else {
            invoice.rows[i].ReturnCRV = parseFloat(roundTo((invoice.rows[i].CRV) * ReturnWeightsList.length), 2).toFixed(2) || invoice.rows[i].ReturnCRV || 0;
          }
          // invoice.rows[i].TotalPrice = parseFloat(ReturnTotalPrice);
        }
      }
      this.setState({ invoice });
    }

    returnTotalWeight(totalWeight) {
      console.log('this is the return weight', totalWeight);
    }

    renderCreditInvoice(unpaidInvoices) {
      const invoiceOptions = [];
      if (unpaidInvoices) {
        unpaidInvoices.map((invoice) => {
          invoiceOptions.push({value: invoice.InvoiceNum, label: invoice.InvoiceNum});
        })
      }
      return (
        <Field name="CreditInvoiceNum" component={Selection} disabled={this.props.params.id} matchPos="any" options={invoiceOptions} />
      );
    }

    renderInvoice() {
      const that = this;
      if (this.props.isLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;

      // Parameters of the react-data-grid

      const getRows = () => Data.Selectors.getRows(this.state.invoice);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const invoice = Object.assign({}, this.state.invoice, { sortColumn, sortDirection });
        this.setState({ invoice });
      };

      const handleRowUpdated = (e) => {
        const rows = getRows(); // this.state.invoice.rows;
        const invoice = { ...this.state.invoice }
        if (e.cellKey === 'ReturnQuantity' && (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product' || (isGGI && this.state.invoice.rows[e.rowIdx].ProductType === 'Service')) ) {
          let returnQuantity;
          returnQuantity = e.updated.ReturnQuantity;
          if (isVAK) {
            let rowData = invoice.rows[e.rowIdx]
            const returnQuantityNum = parseFloat(returnQuantity) || 0;
            if (returnQuantityNum <= 0 || !this.props.params.id && rowData.LoadedQuantity && (!e.updated.ReturnQuantity || e.updated.ReturnQuantity && rowData.LoadedQuantity - rowData.ReturnedQuantity < parseFloat(e.updated.ReturnQuantity)) || this.props.params.id && rowData.InvoiceQuantity && (!e.updated.ReturnQuantity || e.updated.ReturnQuantity && rowData.InvoiceQuantity - rowData.ReturnedQuantity < parseFloat(e.updated.ReturnQuantity))) {
              return;
            }
            if (rowData.Attributes2 === 'finished_parts' && !!invoice.rows[e.rowIdx].SalesInvoiceLine_id && returnQuantityNum > 0 && returnQuantityNum <= (rowData.LoadedQuantity || rowData.InvoiceQuantity) - rowData.ReturnedQuantity) {
              this.setState({
                totalLoaded: !this.props.params.id ?  parseFloat(rowData.LoadedQuantity - rowData.ReturnedQuantity) : parseFloat(rowData.InvoiceQuantity - rowData.ReturnedQuantity) ,
                currentSerialNo: rowData.SerialNum2 || '',
                currentRowIdx: e.rowIdx,
                serialArrData: !this.props.params.id ? (rowData.serialArrData || []) :
                rowData.SerialNum2.split(',').map((item, index) => {
                  if (rowData.SerialNum.split(',').includes(item)) {
                    return {
                      Num: item,
                      isSelected: true
                    }
                  } else {
                    return {
                      Num: item,
                      isSelected: false
                    }
                  }
                }),
                checkNum: parseFloat(returnQuantity)
              }, () => {
                this.setState({
                  serialNumOpen: true,
                })
              });
            }
          }
          if (!isVAK) {
            if (invoice.rows[e.rowIdx].LoadedQuantity && (invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity) < parseFloat(e.updated.ReturnQuantity)) {
              invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
            } else if (invoice.rows[e.rowIdx].LoadedQuantity) {
              invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
            }
            if (invoice.rows[e.rowIdx].InvoiceQuantity && (invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity) < parseFloat(e.updated.ReturnQuantity)) {
              invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
            } else if (invoice.rows[e.rowIdx].InvoiceQuantity) {
              invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
            }
            if (parseFloat(e.updated.ReturnQuantity) < 0) {
              invoice.rows[e.rowIdx].ReturnQuantity = 0;
            }
            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(invoice.rows[e.rowIdx].ReturnQuantity);
          } else {
            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(returnQuantity);
          }
          invoice.rows[e.rowIdx].ReturnWeight = (invoice.rows[e.rowIdx].LoadedQuantity) ?
            ((invoice.rows[e.rowIdx].TotalNetWeight / invoice.rows[e.rowIdx].LoadedQuantity) * invoice.rows[e.rowIdx].ReturnQuantity) :
            ((invoice.rows[e.rowIdx].InvoiceWeight / invoice.rows[e.rowIdx].InvoiceQuantity) * invoice.rows[e.rowIdx].ReturnQuantity);

          invoice.rows[e.rowIdx].ReturnWeight = +roundTo(invoice.rows[e.rowIdx].ReturnWeight, 2).toFixed(2);
          // console.log('invoice weight', {
          //   check: invoice.rows[e.rowIdx].ReturnWeight, totalWeight: invoice.rows[e.rowIdx].TotalNetWeight, quantity: (invoice.rows[e.rowIdx].LoadedQuantity) ? invoice.rows[e.rowIdx].LoadedQuantity : invoice.rows[e.rowIdx].InvoiceQuantity, ReturnQuantity: invoice.rows[e.rowIdx].ReturnQuantity,
          // });
          if (isHMM && invoice.rows[e.rowIdx].MeasureUnit === 'SFT') {
            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice * Number(invoice.rows[e.rowIdx].PackageSize_1), 2)).toFixed(2);
          } else if ((isEKC || isLMH) && invoice.rows[e.rowIdx].ProductNum.slice(0,4) === '0101') {
            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice * Number(invoice.rows[e.rowIdx].SqftPack), 2)).toFixed(2);
          } else {
            if(isGGI) { //
                invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].PackageSize_1 * invoice.rows[e.rowIdx].SmallUnitPrice, 2)).toFixed(2);
            } else {
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
            }
          }
          if (this.props.params.id) {
            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
          } else {
            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
          }
          this.setState({ invoice });
        } else if (e.cellKey === 'ReturnQuantity' && this.state.invoice.rows[e.rowIdx].ProductType === 'Per-Pound') {
          const invoice = { ...this.state.invoice };
          if (invoice.rows[e.rowIdx].LoadedQuantity && (invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity) < parseFloat(e.updated.ReturnQuantity)) {
            invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
          } else if (invoice.rows[e.rowIdx].LoadedQuantity) { invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity); }
          if (invoice.rows[e.rowIdx].InvoiceQuantity && (invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity) < parseFloat(e.updated.ReturnQuantity)) {
            invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
          } else if (invoice.rows[e.rowIdx].InvoiceQuantity) {
            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
          }
          if (parseFloat(e.updated.ReturnQuantity) < 0) {
            invoice.rows[e.rowIdx].ReturnQuantity = 0;
          }
          invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(invoice.rows[e.rowIdx].ReturnQuantity);
          invoice.rows[e.rowIdx].ReturnWeight = (invoice.rows[e.rowIdx].LoadedQuantity) ?
            ((invoice.rows[e.rowIdx].TotalNetWeight / invoice.rows[e.rowIdx].LoadedQuantity) * invoice.rows[e.rowIdx].ReturnQuantity) :
            ((invoice.rows[e.rowIdx].InvoiceWeight / invoice.rows[e.rowIdx].InvoiceQuantity) * invoice.rows[e.rowIdx].ReturnQuantity);

          invoice.rows[e.rowIdx].ReturnWeight = +roundTo(invoice.rows[e.rowIdx].ReturnWeight, 2).toFixed(2);
          // console.log('invoice weight', {
          //   check: invoice.rows[e.rowIdx].ReturnWeight, totalWeight: invoice.rows[e.rowIdx].TotalNetWeight, quantity: (invoice.rows[e.rowIdx].LoadedQuantity) ? invoice.rows[e.rowIdx].LoadedQuantity : invoice.rows[e.rowIdx].InvoiceQuantity, ReturnQuantity: invoice.rows[e.rowIdx].ReturnQuantity,
          // });
          if(isGGI) {
            invoice.rows[e.rowIdx].ReturnTotalPrice = (invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].SmallUnitPrice);
          } else {
            invoice.rows[e.rowIdx].ReturnTotalPrice = (invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].UnitPrice);
          }
          invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnTotalPrice, 2)).toFixed(2);
          if (this.props.params.id) {
            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
          } else {
            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
          }
          this.setState({ invoice });
        }
        if (e.cellKey === 'UnitPrice') {
          const invoice = { ...this.state.invoice };
          // Update Return Total Price
          invoice.rows[e.rowIdx].UnitPrice = +parseFloat(roundTo(rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
          if (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product') {
            if (isHMM && invoice.rows[e.rowIdx].MeasureUnit === 'SFT') {
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice * Number(invoice.rows[e.rowIdx].PackageSize_1), 2)).toFixed(2);
            } else if ((isEKC || isLMH) && invoice.rows[e.rowIdx].ProductNum.slice(0,4) === '0101') {
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice * Number(invoice.rows[e.rowIdx].SqftPack), 2)).toFixed(2);
            } else {
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
            }
          } else {
            invoice.rows[e.rowIdx].ReturnTotalPrice = (invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].UnitPrice);
          }
          this.setState({ invoice });
        }
        if (e.cellKey === 'ReturnReason') {
          const invoice = { ...this.state.invoice };
          invoice.rows[e.rowIdx].ReturnReason = e.updated.ReturnReason;
          this.setState({ invoice });
        }
        Object.assign(rows[e.rowIdx], e.updated);
      };

      // const returnReasonOptions = [
      //   { id: 0, title: 'Damaged' },
      //   { id: 1, title: 'Defective' },
      //   { id: 2, title: 'Not Needed' },
      //   { id: 3, title: 'Repair' },
      //   { id: 4, title: 'Wrong Item' },
      //   { id: 5, title: 'Other' },
      //   { id: 6, title: 'Missing' },
      // ];

      const returnReasonOptions = [
        'Damaged',
        'Defective',
        'Not Needed',
        'Repair',
        'Wrong Item',
        'Other',
        'Missing',
        'Out',
        'Short',
      ];

      const IsVariableFormatter = React.createClass({
        render() {
          return (<span><Button
            bsStyle="danger"
            className="textAlignStyle"
            style={{ height: '23px', width: '39px', padding: '0px' }}
            onClick={() => {
                    const ProductNum = this.props.dependentValues.ProductNum;
                    that.removeRow(ProductNum);
                  }}
          >X
                        </Button>
          </span>);
        },
      });

      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedRows = [...this.state.invoice.selectedRows];
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
          if (!newRows[r.rowIdx].Restock) { newRows[r.rowIdx].Restock = 0; }
          selectedRows.push(r.row);
        });
        const invoice = { ...this.state.invoice, rows: newRows, selectedRows };
        this.setState({ invoice });
      };

      const onRowsDeselected = (rows) => {
        const newRows = [...this.state.invoice.rows];
        const selectedRows = [...this.state.invoice.selectedRows];
        selectedRows.map((r, index) => {
          if (r.Product_id === rows[0].row.Product_id) {
            selectedRows.splice(index, 1);
          }
        });
        newRows.map((r, index) => {
          if (r.Product_id === rows[0].row.Product_id) {
            newRows[index].isSelected = false;
          }
        });
        const invoice = { ...this.state.invoice, rows: newRows, selectedRows };
        this.setState({ invoice });
      };
      // let reasonEditor = <DropDownEditor options={returnReasonOptions} />;
      // let reasonFormattor = <DropDownFormatter options={returnReasonOptions} value='bug' />;

      const IsFixedFormatter = React.createClass({
        render() {
          if (this.props.dependentValues.ProductType === 'Non-Fixed') {
            return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
          } else if (this.props.dependentValues.ProductType === 'Per-Pound') {
            return <span>{this.props.value} <label className="label label-primary"><Translate value="per_pound" /></label></span>;
          }
          return <span>{this.props.value}</span>;
        },
      });

      const ReturnWeightFormatter = React.createClass({
        render() {
          // if (this.props.dependentValues.ReturnQuantity)
          //   return (
          //       (this.props.dependentValues.ProductType === "Non-Fixed") ?
          //         <span>{(this.props.dependentValues.ReturnWeight ||  this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span> :
          //         <span>{
          //           (this.props.dependentValues.LoadedQuantity) ?
          //           ((this.props.dependentValues.TotalNetWeight/this.props.dependentValues.LoadedQuantity) * this.props.dependentValues.ReturnQuantity) :
          //           ((this.props.dependentValues.TotalNetWeight/this.props.dependentValues.InvoiceQuantity) * this.props.dependentValues.ReturnQuantity)
          //         }</span>
          //   );
          // else {
          return (<span>{(this.props.dependentValues.ReturnWeight || this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span>);
          // }
        },
      });

      const ReturnFormatter = React.createClass({
        render() {
          if (this.props.dependentValues) {
            if (!this.props.dependentValues.ReturnQuantity && this.props.dependentValues.ProductType === 'Non-Fixed') {
              return (
                <div><Button
                  bsStyle="primary"
                  className="textAlignStyle"
                  style={{ height: '20px', width: '120px', padding: '0px' }}
                  disabled={!this.props.dependentValues.isSelected}
                  onClick={() => {
                    const currentWeights = { ...this.props.dependentValues };
                    currentWeights.Weights = [...this.props.dependentValues.ReturnableWeightsList];
                    that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights });
                    that.openWeightModule(this.props.dependentValues);
                  }}
                ><Translate value="process" />
                      </Button>
                </div>);
            } else if (this.props.dependentValues.ProductType === 'Fixed' || this.props.dependentValues.ProductType === 'Non-Product' || this.props.dependentValues.ProductType === 'Per-Pound') {
              return (
                <span>{(this.props.dependentValues.ReturnQuantity || this.props.dependentValues.ReturnQuantity === 0) ? this.props.dependentValues.ReturnQuantity : ''}</span>
              );
            }
            return (
              <span>{(this.props.dependentValues.ReturnQuantity)}{' '}<Button
                bsStyle="warning"
                className="textAlignStyle"
                style={{ height: '20px', width: '60px', padding: '0px' }}
                disabled={!this.props.dependentValues.isSelected}
                onClick={() => {
                  const currentWeights = { ...this.props.dependentValues };
                  currentWeights.Weights = [...this.props.dependentValues.ReturnableWeightsList];
                  that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights });
                  that.openWeightModule(this.props.dependentValues);
                }}
              ><Translate value="change" />
              </Button>
              </span>);
          }
        },
      });


      const ReturnFormatter2 = React.createClass({
        render() {
          if (this.props.dependentValues) {
            return (this.props.dependentValues.ProductType === 'Non-Fixed') ?
              <span style={{ 'padding-right': '5px' }}>{(this.props.dependentValues.ReturnQuantity)}{' '}<Button
                bsStyle="warning"
                className="textAlignStyle"
                style={{ height: '20px', width: '60px', padding: '0px' }}
                disabled={!this.props.dependentValues.isSelected}
                onClick={() => {
                    /* var ProductNum = this.props.dependentValues.ProductNum;
                    that.removeRow(ProductNum); */
                    const currentWeights = {};
                    currentWeights.Weights = [...this.props.dependentValues.InvoiceWeightsList];
                    that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights });
                    that.openWeightModule(this.props.dependentValues);
                  }}
              ><Translate value="change" />
                                                                                                         </Button>
              </span> :
              <span>{(this.props.dependentValues.ReturnQuantity || this.props.dependentValues.ReturnQuantity === 0) ? this.props.dependentValues.ReturnQuantity : ''}</span>;
          }
        },
      });

      const TotalPriceFormatter = React.createClass({
        render() {
          return (
            (that.props.params.id) ?
              <span>{(this.props.dependentValues.ProductType === 'Fixed') ?
                      parseFloat(roundTo(this.props.dependentValues.ReturnQuantity * this.props.dependentValues.UnitPrice, 2)).toFixed(2) :
                      parseFloat(roundTo(this.props.dependentValues.ReturnWeight * this.props.dependentValues.UnitPrice, 2)).toFixed(2)
                    }
              </span> :
              <span>{this.props.dependentValues.TotalPrice}</span>
          );
        },
      });

      const columns = (!this.props.params.id) ?
        [
          ...isOLG ? [] : [{
            key: 'ProductNum',
            name: <Translate value="product_num" />,
            resizable: true,
            sortable: true,
            width: 140,
            // filterable: true,
          }],
          {
            key: 'RefNum',
            name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
            resizable: true,
            sortable: true,
            width: 100,
            // filterable: true,
            isHide: (isEKC || isLMH || isSDR || isCRW),
          },
          {
            key: 'Name',
            name: <Translate value="name" />,
            resizable: true,
            sortable: true,
            width: 140,
            // filterable: true,
          },
          {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            width: 160,
            // filterable: true,
          },
          {
            key: 'OriginalPrice',
            name: <Translate value="orig_price" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            formatter: CashFormatter,
            isHide: (!isLMH),
          },
          {
            key: 'UnitPrice',
            name: <Translate value="unit_price" />,
            resizable: true,
            sortable: true,
            editable: row => ((row.SalesInvoiceLine_id === null || row.SalesInvoiceLine_id === undefined) && row.isSelected),
            width: 80,
            // filterable: true,
            formatter: CashFormatter,
          },
          {
            key: 'IsTaxable',
            name: <Translate value="taxable" />,
            resizable: true,
            sortable: true,
            width: 80,
            formatter: ({ value }) => (
              <div style={{color: (value === true || value === "true") ? "green": "red"}}>
                { (value === true || value === 'true') ? "true" : "false" }
              </div>
            ),
            isHide: !(isLMH || isSDR || isCRW),
          },
          ...(isEKC || isLMH) ? [{key: 'SqftPack',
          name: <Translate value="sqft/pack" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true}] : [],
          {
            key: 'LoadedQuantity',
            name: <Translate value={isVAK ? "inv_qty_vak" : "inv_qty"} />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            formatter: IsFixedFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'TotalNetWeight',
            name: <Translate value={isVAK ? "inv_wt_vak" : "inv_wt"} />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            isHide: (isEKC || isLMH || isSDR || isCRW),
          },
          {
            key: 'ReturnedQuantity',
            name: <Translate value="rtned_qty" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
          },
          {
            key: 'IsNoReturn',
            name: <Translate value="no_return" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            // getRowMetaData: row => row,
            formatter: (props) => {
              const {
                value,
              } = props;
              // const value = true;
              return (<span style={{
                width: '100%',
                display: 'block',
                textAlign: 'center',
                color: 'white',
                backgroundColor: value ? 'red' : 'green',
              }}>{`${value}`}</span>)
            },
          },
          {
            key: 'ReturnQuantity',
            name: <Translate value="return_qty" />,
            resizable: true,
            sortable: true,
            editable: row => (row.ProductType !== 'Non-Fixed' && row.isSelected),
            width: 130,
            // filterable: true,
            formatter: ReturnFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'ReturnWeight',
            name: <Translate value="rtn_wt" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            formatter: ReturnWeightFormatter,
            getRowMetaData: row => row,
            isHide: (isEKC || isLMH || isSDR || isCRW),
          },
          {
            key: 'ReturnTotalPrice',
            name: <Translate value="total_price" />,
            resizable: true,
            sortable: true,
            width: 100,
            // filterable: true,
            formatter: CashFormatter,
          },
          {
            key: 'ReturnReason',
            name: <Translate value="return_reason" />,
            resizable: true,
            sortable: true,
            width: 120,
            editor: <DropDownEditor options={returnReasonOptions}/>,
          },
        ].filter(item => !item.isHide) :
        [
          {
            key: 'ProductNum',
            name: <Translate value="product_num" />,
            resizable: true,
            sortable: true,
            width: 110,
            // filterable: true,
          },
          {
            key: 'Name',
            name: <Translate value="name" />,
            resizable: true,
            sortable: true,
            width: 140,
            // filterable: true,
          },
          {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            width: 150,
            // filterable: true,
          },
          {
            key: 'UnitPrice',
            name: <Translate value="unit_price" />,
            resizable: true,
            sortable: true,
            editable: row => ((row.SalesInvoiceLine_id === null || row.SalesInvoiceLine_id === undefined) && row.isSelected),
            width: 120,
            // filterable: true,
            formatter: CashFormatter,
          },
          ...(isEKC || isLMH) ? [{key: 'SqftPack',
          name: <Translate value="sqft/pack" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true}] : [],
          {
            key: 'InvoiceQuantity',
            name: <Translate value={isVAK ? "inv_qty_vak" : "inv_qty"} />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            formatter: IsFixedFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'InvoiceWeight',
            name: <Translate value={isVAK ? "inv_wt_vak" : "inv_wt"} />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
          },
          {
            key: 'ReturnedQuantity',
            name: <Translate value="rtned_qty" />,
            resizable: true,
            sortable: true,
            width: 110,
            // filterable: true,
          },
          {
            key: 'ReturnQuantity',
            name: <Translate value="return_qty" />,
            resizable: true,
            sortable: true,
            editable: row => (row.ProductType !== 'Non-Fixed' && row.isSelected),
            width: 100,
            // filterable: true,
            formatter: ReturnFormatter2,
            getRowMetaData: row => row,
          },
          {
            key: 'ReturnWeight',
            name: <Translate value="rtn_wt" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            formatter: ReturnWeightFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'ReturnTotalPrice',
            name: <Translate value="total_price" />,
            resizable: true,
            sortable: true,
            width: 120,
            // filterable: true,
            formatter: CashFormatter,
            // formatter:  TotalPriceFormatter,
            // getRowMetaData: (row) => row,
          },
          {
            key: 'ReturnReason',
            name: <Translate value="return_reason" />,
            resizable: true,
            sortable: true,
            editor: <DropDownEditor options={returnReasonOptions}/>,
          },
        ];

      return (
        <Row>
          <Col sm={12}>
            <div id="CustomerReturnForm-dataGrid1">
              <ReactDataGrid
                rowKey="Product_id"
                onGridSort={handleGridSort}
                columns={columns}
                headerRowHeight={45}
                rowHeight={35}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowUpdated={handleRowUpdated}
                minHeight={this.state.tableHeight}
                // onGridRowsUpdate={() => { console.log('grid row updating'); }}
                enableRowSelect="single"
                enableCellSelect
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
              />
            </div>
          </Col>
        </Row>


      );
    }

    checkValues = (selected) => {
      for (let i = 0; i < selected.length; i++) {
        if (!selected[i].ReturnQuantity || selected[i].ReturnQuantity === null || selected[i].ReturnQuantity === 0) {
          alert('Quantity cannot be zero or blank, if you want to remove a row please deselect it');
          return false;
        }
      }
      return true;
    }

    handleComplete = (TotalPrice, Tax, CRV, RestockingFee, RestockingFeePercentage, FinalPrice, Note, Redeliver, ReturnedSavings, OverwriteFee) => {
      let ReturnStatus = false;
      for (let i = 0; i < this.state.invoice.selectedRows.length; i++) {
        if (!this.state.invoice.selectedRows[i].ReturnReason) {
          ReturnStatus = true;
          i = this.state.invoice.selectedRows.length;
        }
      }
      if (!ReturnStatus) {
        if (!this.props.params.id) {
          if (this.checkValues(this.state.invoice.selectedRows)) {
            this.props.createSalesReturn(
              this.props.salesInvoiceDetail.InvoiceNum,
              TotalPrice,
              Tax,
              CRV,
              RestockingFee,
              RestockingFeePercentage,
              FinalPrice,
              Note,
              this.state.invoice,
              this.props.salesInvoiceDetail.SalesInvoice_id,
              (this.props.CreditInvoiceNum)? this.props.CreditInvoiceNum.value : '',
              this.props.PostingDate,
              Redeliver,
              ReturnedSavings,
              OverwriteFee,
              isVAK ? true : false
            );
          }
        } else if (this.checkValues(this.state.invoice.selectedRows)) {
          this.props.editSalesReturn(
            this.props.salesReturnDetail.SRNum,
            TotalPrice,
            Tax,
            CRV,
            RestockingFee,
            RestockingFeePercentage,
            FinalPrice,
            Note,
            this.state.invoice,
            this.props.params.id,
            (this.props.CreditInvoiceNum)? this.props.CreditInvoiceNum.value : '',
            this.props.PostingDate,
            ReturnedSavings,
            OverwriteFee,
            isVAK ? true : false
          );
        }
      } else {
        alert('Please specify a Return Reason(s) for issuing credit');
      }
    }


    handleRestock = (e) => {
      if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
        const curRestock = e.target.value;
        const invoice = { ...this.state.invoice };
        let curRestockP = 0;
        let total = 0

        for (let i = 0; i < invoice.selectedRows.length; i++) {
          total += invoice.selectedRows[i].ReturnTotalPrice ? Number(invoice.selectedRows[i].ReturnTotalPrice) : 0;
        }
        curRestockP = curRestock ? (Number(curRestock)*100)/total : 0;
        curRestockP = curRestockP.toFixed(2);

        this.setState({ curRestock, curRestockP, invoice });
      } else if (e.target.value === '') {
        this.setState({ curRestock: '', curRestockP: '' });
      }
    }

    handleRestockP = (e) => {
      if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
        let curRestock = 0;
        const curRestockP = e.target.value;
        const invoice = { ...this.state.invoice };

        for (let i = 0; i < invoice.selectedRows.length; i++) {
          curRestock += invoice.selectedRows[i].ReturnTotalPrice ? Number(invoice.selectedRows[i].ReturnTotalPrice)*(Number(curRestockP)/100) : 0;
          // total += (invoice.selectedRows[i].ReturnTotalPrice) ? roundTo(parseFloat(invoice.selectedRows[i].ReturnTotalPrice), 2) : 0;
        }
        curRestock = curRestock.toFixed(2);

        this.setState({ curRestockP, curRestock, invoice });
      } else if (e.target.value === '') {
        this.setState({ curRestockP: '', curRestock: '' });
      }
    }

    handleOverwrite = (e) => {
      if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
        const curOverwrite = e.target.value;
        const invoice = { ...this.state.invoice };
        this.setState({ curOverwrite, invoice });
      } else if (e.target.value === '') {
        this.setState({ curOverwrite: '' });
      }
    }

    handleNotation = (e) =>{
      this.setState({curNotation: e.target.value});
    }
    closeSerialNum = () => {
      this.setState({serialNumOpen: false});
    }
    setSerialNums = (serialNums) => {
      const { rows } = this.state.invoice;
      if (this.state.currentRowIdx !== null) {
        rows[this.state.currentRowIdx].ReturnQuantity = serialNums;
        rows[this.state.currentRowIdx].ReturnTotalPrice = parseFloat(roundTo(serialNums * rows[this.state.currentRowIdx].UnitPrice, 2)).toFixed(2);
        this.setState({
          invoice: {
            ...this.state.invoice,
            rows,
          },
          currentRowIdx: null,
        })
      }
    }

    returnSerialNums = (serialNums) => {
      const { rows } = this.state.invoice;
      if (this.state.currentRowIdx !== null) {
        rows[this.state.currentRowIdx].SerialNum = !this.props.params.id ? serialNums : this.state.serialArrData.filter(item => item.isSelected).map(item => item.Num).join(',')
        this.setState({
          invoice: {
            ...this.state.invoice,
            rows,
          },
          currentRowIdx: null,
        })
      }
    }

    getSerialArr = (serialArrData) => {
      const { rows } = this.state.invoice;
      if (this.state.currentRowIdx !== null) {
        rows[this.state.currentRowIdx].serialArrData = serialArrData
        rows[this.state.currentRowIdx].SerialNum = serialArrData.filter(item => item.isSelected).map(item => item.Num).join(',')
        this.setState({
          invoice: {
            ...this.state.invoice,
            rows,
          },
          currentRowIdx: null,
          serialArrData
        })
      }
    }
    render() {
      const createDialogInventoryStyle = {
        height: '700px',
        width: '1000px',
        marginLeft: '-28%',
        marginTop: '-20%',
      };
      const createDialogStyleWeight = {
        width: '500px',
        height: '600px',
        top: '45%',
        marginLeft: '-10%',
      };
      let createDialogStyle = {
        width: '500px',
        height: '500px',
        top: '45%',
        marginLeft: '-10%',
      };
      const selectInventoryInformation = (<Translate value="select_inventory_information" />);
      const salesInvoiceDetail = (!this.props.params.id) ? {...this.props.salesInvoiceDetail, Invoice_User_Name: this.props.salesInvoiceDetail && this.props.salesInvoiceDetail.Modifier_User_Name || ''} : this.props.salesReturnDetail;
      if (this.props.salesReturnDetail && this.props.salesReturnDetail.SRNum) { salesInvoiceDetail.InvoiceNum = (this.props.params.id) ? this.props.salesReturnDetail.SRNum.slice(0, -1) : salesInvoiceDetail.InvoiceNum; }
      const { handleSubmit } = this.props;
      let Customer_Name = '';
      if (salesInvoiceDetail) {
        Customer_Name = (salesInvoiceDetail.Customer_Name) ? salesInvoiceDetail.Customer_Name : salesInvoiceDetail.Deliver_Customer_Name;
      }
      let tax = 0;
      let total = 0;
      let CRV = 0;
      let finalPrice = 0;
      for (let i = 0; i < this.state.invoice.selectedRows.length; i++) {
        total += (this.state.invoice.selectedRows[i].ReturnTotalPrice) ? roundTo(parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice), 2) : 0;
        if (this.state.invoice.selectedRows[i].IsTaxable && this.state.invoice.selectedRows[i].ReturnTotalPrice) {
          tax += (this.state.invoice.selectedRows[i].ReturnTotalPrice) ? roundTo(parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice), 2) : 0;
        }
        CRV += +roundTo(parseFloat(this.state.invoice.selectedRows[i].CRV || 0) * (parseFloat(this.state.invoice.selectedRows[i].ReturnQuantity) || 0), 2).toFixed(2);
      }

      total = parseFloat(roundTo(total, 2)).toFixed(2);
      CRV = parseFloat(roundTo(CRV, 2)).toFixed(2);

      let discountSpread = 0;
      let returnedSavings = 0;

      discountSpread = (this.state.invoice.Savings && this.state.invoice.TotalPrice) ? ( this.state.invoice.Savings / this.state.invoice.TotalPrice ) : 0;
      returnedSavings = parseFloat(roundTo(total*discountSpread, 2)).toFixed(2);

      if (isLMH || isSUN || isCPG || isSDR || isCRW || isVIP) {
        if (this.props.salesReturnDetail && this.props.salesReturnDetail.CustomerIsReseller) {
          tax = 0;
        } else if (this.props.salesInvoiceDetail && this.props.salesInvoiceDetail.CustomerIsReseller) {
          tax = 0;
        } else {
          tax = 0;
          this.state.invoice.selectedRows.map((r,i) => {
            if (r.IsTaxable) {
              if (r.ProductNum.slice(0,4) === '0101' && !(isSDR || isCRW)) {
                tax += (r.ReturnQuantity ? r.ReturnQuantity : 0) * r.UnitPrice * r.SqftPack;
              } else {
                tax += (r.ReturnQuantity ? r.ReturnQuantity : 0) * r.UnitPrice;
              }
            }
          });
        }
      } else {
        if (this.props.salesReturnDetail && this.props.salesReturnDetail.CustomerIsReseller) {
          tax = 0;
        } else if (this.props.salesInvoiceDetail && this.props.salesInvoiceDetail.CustomerIsReseller) {
          tax = 0;
        } else {
          if ((tax > 0) && (tax - returnedSavings >= 0)) {
            tax = tax - returnedSavings;
          } else {
            tax = 0;
          }
        }
      }

      tax *= (parseFloat(this.state.invoice.TaxRate || 0) / 100.0);
      tax = parseFloat(roundTo(tax, 2)).toFixed(2);

      finalPrice = parseFloat(roundTo((parseFloat(total) || 0) + (parseFloat(CRV) || 0) + (parseFloat(tax) || 0) - (parseFloat(this.state.curRestock) || 0) - (parseFloat(returnedSavings) || 0), 2)).toFixed(2);

      if ((isEKC || isLMH || isSDR || isCRW) && this.state.curOverwrite) {
        tax = 0;
        total = 0;
        CRV = 0;
        returnedSavings = 0;
        this.state.curRestock = 0;
        this.state.curRestockP = 0;
        finalPrice = Number(this.state.curOverwrite);
      }
      return (
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="returns" />
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Translate value="sales_return" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              {(!this.props.params.id) ? <Translate value="create_sales_return" /> : <Translate value="edit_sales_return" />}
            </Breadcrumb.Item>
          </Breadcrumb>
          <ButtonToolbar id="breadcrumbButtonGroup">
            {
              !this.props.params.id &&
              <Button
                bsStyle="success"
                disabled={this.state.invoice.selectedRows.length === 0 || this.props.salesReturnIsCreating}
                onClick={() => { this.handleComplete(total, tax, CRV, this.state.curRestock, this.state.curRestockP, finalPrice, this.state.curNotation, true, returnedSavings, Number(this.state.curOverwrite)); }}
              >
                <span><em className="fa fa-check" /><Translate value="redeliver" /></span>
              </Button>
            }
            <Button
              bsStyle="success"
              disabled={this.state.invoice.selectedRows.length === 0 || this.props.salesReturnIsCreating || isVAK && this.props.salesReturnDetail && (this.props.salesReturnDetail.RestockStatus === 'Done' || this.props.salesReturnDetail.ReturnStatus === 'Void')}
              onClick={() => { this.handleComplete(total, tax, CRV, this.state.curRestock, this.state.curRestockP, finalPrice, this.state.curNotation, false, returnedSavings, Number(this.state.curOverwrite)); }}
            >
              {(!this.props.params.id) ?
                <span><em className="fa fa-check" /><Translate value="complete_return" /></span> :
                <span><em className="fa fa-save" />{isSV ? " Save & Sync QB" : <Translate value="save" />} </span>
              }
            </Button>
            <Button
              bsStyle="danger"
              type="button"
              onClick={() => { browserHistory.goBack() }}
            >
              <em className="fa fa-close" /><Translate value="cancel" />
            </Button>
          </ButtonToolbar>
          <br />
          <Grid id="sales-customer-return-form" >
            {/* <Row>
              <Col xs={12}>
                <h1>{(!this.props.params.id) ? <Translate value="create_sales_return" /> : <Translate value="edit_sales_return" />}</h1>
              </Col>
            </Row> */}
            <Row>
              <Col xs={8}>
                <Panel>
                  <Row>
                    <Col sm={3}>
                      <Row>
                        <Col xs={12}>
                            <h3><Translate value="customer" /></h3>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={5}>
                            <label><Translate value="name" />:</label>
                          </Col>
                        <Col xs={7}>
                            {Customer_Name}
                          </Col>
                      </Row>

                    </Col>
                    {(salesInvoiceDetail && salesInvoiceDetail.SalesInvoice_id) ?
                      <Col xs={3}>
                        <Row>
                            <Col xs={12}>
                              <h3><Translate value="invoice" /></h3>
                            </Col>
                          </Row>
                        <Row>
                            <Col xs={2}>
                              <label><Translate value="no" />:</label>
                            </Col>
                            <Col xs={7}>
                              {salesInvoiceDetail && salesInvoiceDetail.InvoiceNum}
                            </Col>
                          </Row>
                        <Row>
                            <Col xs={3}>
                              <label><Translate value="sales" />:</label>
                            </Col>
                            <Col xs={7}>
                              {salesInvoiceDetail && salesInvoiceDetail.Sales_User_Name}
                            </Col>
                          </Row>
                          {isGGI && <Row>
                        <Col xs={5}>
                            <label><Translate value="inv_modifier" />:</label>
                          </Col>
                        <Col xs={7}>
                            {salesInvoiceDetail && salesInvoiceDetail.Invoice_User_Name /* right? */}
                          </Col>
                      </Row>}
                      </Col> :
                      <Col xs={3} />
                      }
                    <Col xs={3}>

                      <Row>
                        <Col xs={12}>
                          <h3><Translate value="credit_invoice" /></h3>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={4}>
                            <label><Translate value="no" />:</label>
                          </Col>
                        <Col xs={8}>
                            { this.renderCreditInvoice(this.props.unpaidInvoices) }
                          </Col>
                      </Row>

                    </Col>
                    <Col xs={3}>
                      <Row>
                        <Col xs={12}>
                            <h3><Translate value="return" /></h3>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={5}>
                            <label><Translate value="no" />:</label>
                          </Col>
                        <Col xs={7}>
                            {
                              (salesInvoiceDetail && salesInvoiceDetail.SRNum) ?
                              salesInvoiceDetail && salesInvoiceDetail.SRNum :
                              salesInvoiceDetail && (`${salesInvoiceDetail.InvoiceNum}R`)
                            }
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={5}>
                            <label><Translate value="return_date" />:</label>
                          </Col>
                        <Col xs={7}>
                            <Field name="PostingDate" selected={moment().format('MM-DD-YY')} component={StartOfThisMonthDatePicker} />
                          </Col>
                      </Row>
                      {isGGI && <Row>
                        <Col xs={6}>
                          <label><Translate value="return_modifier" />:</label>
                        </Col>
                        <Col xs={6}>
                          {salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name }
                        </Col>
                      </Row>
                      }
                      {!isGGI && <Row>
                        <Col xs={5}>
                            <label><Translate value="user" />:</label>
                          </Col>
                        <Col xs={7}>
                            {salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name /* right? */}
                          </Col>
                      </Row>}
                    </Col>
                  </Row>
                </Panel>
              </Col>
              <Col xs={4}>
                <Panel>
                  <Row>
                    <Col xs={12}>
                      <h3><Translate value="return_details" /></h3>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={2}>
                      <Row>
                        <Col xs={12}>
                            <label style={{ display: 'inline-flex' }}><Translate value="total" /><span className="dollar-sign"> $$</span>:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Field name="ReturnTotal" component={DisabledInputField} placeholder={total} />
                          </Col>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="crv" />:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Field name="CRV" component={DisabledInputField} placeholder={CRV} />
                          </Col>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="tax" />:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Field name="Tax" component={DisabledInputField} placeholder={tax} />
                          </Col>
                      </Row>
                    </Col>
                    <Col xs={3}>
                      <Row>
                        <Col xs={12}>
                          <label><Translate value="discount" />:</label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          {!(isLMH || isSDR || isCRW) &&
                          <Field name="Savings" component={DisabledInputField} placeholder={'-' + returnedSavings} />
                          }
                          {(isLMH || isSDR || isCRW) &&
                          <Field name="Savings" component={DisabledInputField} placeholder={'-' + returnedSavings + ' (' + this.state.invoice.Discount + '%)' } />
                          }
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <Col xs={12}>
                            <label style={{ display: 'inline-flex' }}><Translate value="final" /><span className="dollar-sign"> $$</span>:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Field name="FinalTotal" component={DisabledInputField} placeholder={finalPrice} />
                          </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row style={{marginTop: '10px'}}>
                  <Col xs={3}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="restock" />($):</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Input name="curRestock" type="number" onChange={this.handleRestock} value={this.state.curRestock} />
                          </Col>
                      </Row>
                    </Col>
{(isSDR || isCRW || isCCW) &&
                    <Col xs={3}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="restock" />(%):</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Input name="curRestockP" type="number" onChange={this.handleRestockP} value={this.state.curRestockP} />
                          </Col>
                      </Row>
                    </Col>
    }
                    <Col xs={5}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="notation" />:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Input name="curNotation" type="text" onChange={this.handleNotation} value={this.state.curNotation} />
                          </Col>
                      </Row>
                    </Col>
                  </Row>
                {
                  (isEKC || isLMH || isSDR || isCRW) &&
                  <Row style={{marginTop: '0px'}}>
                  <Col xs={4}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="overwrite_value" />:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Input name="curOverwrite" type="text" onChange={this.handleOverwrite} value={this.state.curOverwrite} />
                          </Col>
                      </Row>
                    </Col>
                    {/* <Col xs={7}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="notation" />:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Input name="curNotation" type="text" onChange={this.handleNotation} value={this.state.curNotation} />
                          </Col>
                      </Row>
                    </Col> */}
                  </Row>
    }
                </Panel>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Panel>
                  { this.renderInvoice() }
                </Panel>
              </Col>
            </Row>
          </Grid>

          <SkyLightStateless
            dialogStyles={createDialogStyleWeight}
            isVisible={this.state.ReturnModalOpen}
            onCloseClicked={() => { this.closeReturnModal(); }}
            title="Return Products"
          >
            <ReturnModal
              invoice
              setWeights={this.setWeights}
              keepLoaded={() => {}}
              currentWeights={this.state.currentWeights}
              allWeights={this.state.invoiceWeightsList}
              closeC={this.closeReturnModal}
              rowChosen={this.state.rowChosen}
              returnTotalWeight={this.returnTotalWeight.bind(this)} />
          </SkyLightStateless>

          <SkyLightStateless
            dialogStyles={createDialogInventoryStyle}
            isVisible={this.state.showInventoryOpen}
            onCloseClicked={() => {
              this.closeShowInventory('productSearch');
            }}
            title={selectInventoryInformation}
          >
            <SalesInventoryInfo
              Customer_id={this.state.currentCustomer_id}
              SearchType={this.props.searchType}
              SearchValue={this.props.searchValue}
              closeShowInventory={this.closeShowInventory}
              selectInventoryInfo={this.selectInventoryInfo}
              setSaleRowValue={this.props.setSaleRowValue}
              setAllProductQuantity={this.setAllProductQuantity}
              formName="customerReturnForm"
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.serialNumOpen}
            onCloseClicked={() => { this.closeSerialNum() }}
            title={<Translate value="select_serial_num" />}>
            <SerialNumModal
              closeC={this.closeSerialNum}
              totalLoaded={ this.state.totalLoaded }
              returnSerialNums={ this.returnSerialNums }
              getSerialArr={this.getSerialArr}
              keepLoaded={() => {}}
              oldLoaded={0}
              currentSerialNo={this.state.currentSerialNo}
              serialArrData = {this.state.serialArrData}
              setSerialNums={this.setSerialNums}
              isCheckAble={ isVAK ? true : false}
              checkNum = {this.state.checkNum}
            />
          </SkyLightStateless>
        </ContentWrapper>
      );
    }
}

const renderTypeRadios = props => (
  <div className="form-group" id="search-product-by">
    <label className="col-xs-3 search-by-max-width">
      <Translate value="search_by" />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="ProductNum"
        checked={props.input.value === 'ProductNum'}
      />
      <Translate value="prod_num" />
    </label>
    <label className="col-xs-2">
      <input
        {...props.input}
        type="radio"
        value="RefNum"
        checked={props.input.value === 'RefNum'}
      />
      <Translate value={isOLG ? "item_no" : "ref_num"} />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="Name"
        checked={props.input.value === 'Name'}
      />
      <Translate value="name" />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="Description"
        checked={props.input.value === 'Description'}
      />
      <Translate value="description" />
    </label>
  </div>
);

export default CustomerReturnForm;

function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }

  const multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  const test = (Math.round(n) / multiplicator);
  return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/customerReturnForm.jsx